import AbstractApiModel from '@/models/abstracts/AbstractApiModel';
import doc from '@model-core/decorators/doc';

/** Rôle dans l'application (enum App\Entity\AppRole de l'API, GET /app_roles) : id, reference (clé utilisée par le front), label */
export default class AppRoleModel extends AbstractApiModel {
  protected _path = '/app_roles/{?id}';

  @doc.string declare reference: string;
  @doc.string declare label: string;

  /** URN à envoyer à l'API pour écrire la relation (corps d'un POST / PATCH) ; un filtre prend l'id */
  get urn(): string {
    return this.get<string, string>('@urn', `$:teiji:app_role:${this.id}`);
  }
}
